import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

// Import components
import Arrival from './components/Arrival';
import Departure from './components/Departure';
import { configurationSelectors } from 'store/selectors'
import { getConfiguration } from '../../store/actions';

function Start() {
	const dispatch = useDispatch();
	const { isLoading, item, isError, error } = useSelector(
		configurationSelectors.getAll
	);

	React.useEffect(() => {
		if (!(item || isLoading)) {
			getConfiguration()(dispatch);
		}
		// eslint-disable-next-line
	}, []);

	if (isLoading) {
		return null;
	} else {
		if (isError) {
			console.error(error);
			return null;
		} else {
			if (item) {
				switch (item.type) {
					case 'departure':
						return <Departure />;
					case 'arrival':
					default:
						return <Arrival />;
				}
			}
			return null;
		}
	}
}

export default Start;
